/**
 * Static GitHub Pages (`/carvoeiro-nav-mock/app/`) has no Worker.
 * Calling `/api/*` there 404s (or returns the spa HTML). Skip it and
 * use the inlined seed + Open-Meteo so Places/weather never render empty.
 */
export function hasWorkerApi(): boolean {
  if (typeof window !== 'undefined') {
    const { hostname, pathname } = window.location;
    if (/\.github\.io$/i.test(hostname)) return false;
    if (pathname === '/carvoeiro-nav-mock/app' || pathname.startsWith('/carvoeiro-nav-mock/app/')) {
      return false;
    }
  }
  const base = import.meta.env.BASE_URL || '/';
  if (base.includes('carvoeiro-nav-mock')) return false;
  return true;
}
